import Vue from 'vue'
import VueRouter from 'vue-router'
import ListaGrupos from '@/components/ListaGrupo'
import ListaProduto from '@/components/ListaProduto'
import DetalheProduto from '@/components/DetalheProduto'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Grupos',
    component: ListaGrupos,
  },
  {
    path: '/produto/:idGrupo?',
    name: 'Produto',
    component: ListaProduto
  },
  {
    path: '/detalhe-produto',
    name: 'DetalheProduto',
    component: DetalheProduto
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
